<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2>Assign Zone to Agent</h2>
      <button class="close-btn" (click)="onCancel()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- Agent Information -->
      <div class="agent-info-card">
        <div class="agent-info-header">
          <i class="fas fa-user"></i>
          <h3>Agent Information</h3>
        </div>
        <div class="agent-details">
          <div class="detail-row">
            <span class="label">Name:</span>
            <span class="value">{{ agent.name }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Phone:</span>
            <span class="value">{{ agent.phoneNumber }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Agent ID:</span>
            <span class="value">{{ agent.agentId }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Status:</span>
            <span class="status-badge" [class.active]="agent.isActive" [class.inactive]="!agent.isActive">
              {{ agent.isActive ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Currently Assigned Zones -->
      <div class="assigned-zones-card" *ngIf="agent.zones && agent.zones.length > 0">
        <div class="card-header">
          <i class="fas fa-map-marked-alt"></i>
          <h4>Currently Assigned Zones ({{ agent.zones.length }})</h4>
        </div>
        <div class="zones-list">
          <div *ngFor="let zoneId of agent.zones" class="zone-item assigned">
            <div class="zone-info">
              <span class="zone-name">{{ getZoneName(zoneId) }}</span>
              <span class="zone-id">ID: {{ zoneId }}</span>
            </div>
            <div class="zone-status">
              <i class="fas fa-check-circle"></i>
              Assigned
            </div>
          </div>
        </div>
      </div>

      <!-- No Zones Message -->
      <div class="no-zones-card" *ngIf="!agent.zones || agent.zones.length === 0">
        <div class="no-zones-content">
          <i class="fas fa-exclamation-triangle"></i>
          <p>This agent has no zones assigned</p>
        </div>
      </div>

      <!-- Zone Assignment Form -->
      <form (ngSubmit)="onSubmit()" #assignForm="ngForm" class="assign-form">
        <!-- General Error -->
        <div class="error-message" *ngIf="errors['general']">
          <i class="fas fa-exclamation-circle"></i>
          {{ errors['general'] }}
        </div>

        <!-- Zone Selection -->
        <div class="form-group">
          <label for="zoneSelect" class="form-label">
            <i class="fas fa-map-marker-alt"></i>
            Select Zone to Assign <span class="required">*</span>
          </label>
          
          <select
            id="zoneSelect"
            name="zoneSelect"
            [(ngModel)]="selectedZoneId"
            [class.error]="hasError('zone')"
            class="form-select"
            required
            [disabled]="isSubmitting">
            <option value="">Choose a zone...</option>
            <optgroup label="Available Zones" *ngIf="getAvailableZones().length > 0">
              <option *ngFor="let zone of getAvailableZones()" [value]="zone.id">
                {{ zone.name }} (ID: {{ zone.id }})
              </option>
            </optgroup>
          </select>
          
          <div class="field-error" *ngIf="hasError('zone')">
            <i class="fas fa-exclamation-triangle"></i>
            {{ getError('zone') }}
          </div>
          
          <div class="field-info" *ngIf="getAvailableZones().length === 0">
            <i class="fas fa-info-circle"></i>
            All available zones are already assigned to this agent
          </div>
          
          <div class="field-hint" *ngIf="getAvailableZones().length > 0">
            Select a zone from the available options. Already assigned zones are not shown.
          </div>
        </div>

        <!-- Available Zones Preview -->
        <div class="available-zones-preview" *ngIf="getAvailableZones().length > 0">
          <h5>
            <i class="fas fa-list"></i>
            Available Zones ({{ getAvailableZones().length }})
          </h5>
          <div class="zones-grid">
            <div 
              *ngFor="let zone of getAvailableZones().slice(0, 6)" 
              class="zone-preview-card"
              [class.selected]="selectedZoneId === zone.id"
              (click)="selectedZoneId = zone.id">
              <div class="zone-preview-name">{{ zone.name }}</div>
              <div class="zone-preview-id">{{ zone.id }}</div>
              <div class="zone-preview-date" *ngIf="zone.createdAt">
                Created: {{ getFormattedDate(zone.createdAt) }}
              </div>
            </div>
          </div>
          <div class="more-zones" *ngIf="getAvailableZones().length > 6">
            <i class="fas fa-ellipsis-h"></i>
            +{{ getAvailableZones().length - 6 }} more zones available
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="onCancel()"
            [disabled]="isSubmitting">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isSubmitting || !selectedZoneId || getAvailableZones().length === 0">
            <span *ngIf="!isSubmitting">
              <i class="fas fa-map-marker-alt"></i>
              Assign Zone
            </span>
            <span *ngIf="isSubmitting">
              <i class="fas fa-spinner fa-spin"></i>
              Assigning...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
